import { createRouter, createWebHistory } from 'vue-router'

// Views - Lazy loaded for better performance
const HomePage = () => import('@/views/HomePage.vue')
const AboutPage = () => import('@/views/AboutPage.vue')
const ServicesPage = () => import('@/views/ServicesPage.vue')
const ServiceDetailPage = () => import('@/views/ServiceDetailPage.vue')
const CapabilitiesPage = () => import('@/views/CapabilitiesPage.vue')
const IndustriesPage = () => import('@/views/IndustriesPage.vue')
const GalleryPage = () => import('@/views/GalleryPage.vue')
const QualityPage = () => import('@/views/QualityPage.vue')
const ContactPage = () => import('@/views/ContactPage.vue')
const QuotePage = () => import('@/views/QuotePage.vue')
const NotFoundPage = () => import('@/views/NotFoundPage.vue')
const FAQPage = () => import('@/views/FAQPage.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      title: 'Omega Metal Industries - Industrial Fabrication & Machining | Dammam, KSA',
      description: 'A leading industrial fabrication and machining company serving the oil & gas sector in Saudi Arabia since 1996. Precision CNC machining, fabrication, and engineering services.'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
    meta: {
      title: 'About Us - Omega Metal Industries',
      description: 'Learn about our history, mission, and commitment to quality. Serving the oil & gas sector in Saudi Arabia since 1996.'
    }
  },
  {
    path: '/services',
    name: 'Services',
    component: ServicesPage,
    meta: {
      title: 'Our Services - Omega Metal Industries',
      description: 'Precision machining, fabrication, grinding, laser cutting, repair & maintenance, and reverse engineering services in Dammam, KSA.'
    }
  },
  {
    path: '/services/:slug',
    name: 'ServiceDetail',
    component: ServiceDetailPage,
    meta: {
      title: 'Service Details - Omega Metal Industries'
    }
  },
  {
    path: '/capabilities',
    name: 'Capabilities',
    component: CapabilitiesPage,
    meta: {
      title: 'Equipment & Capabilities - Omega Metal Industries',
      description: 'CNC lathes, milling centers, plasma cutting, presses, grinders, heat treatment furnaces, and balancing machines in Dammam, KSA.'
    }
  },
  {
    path: '/industries',
    name: 'Industries',
    component: IndustriesPage,
    meta: {
      title: 'Industries We Serve - Omega Metal Industries',
      description: 'Serving oil & gas, petrochemical, industrial manufacturing, construction, power generation, and mining sectors in Saudi Arabia.'
    }
  },
  {
    path: '/gallery',
    name: 'Gallery',
    component: GalleryPage,
    meta: {
      title: 'Project Gallery - Omega Metal Industries',
      description: 'View our portfolio of precision machined components, fabricated assemblies, and oil & gas projects.'
    }
  },
  {
    path: '/quality',
    name: 'Quality',
    component: QualityPage,
    meta: {
      title: 'Quality Assurance - Omega Metal Industries',
      description: 'API certifications (applied 2024), quality control process, and inspection capabilities for oil & gas components.'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage,
    meta: {
      title: 'Contact Us - Omega Metal Industries',
      description: 'Get in touch with our team in Dammam, KSA for quotes, inquiries, or to discuss your oil & gas machining and fabrication project.'
    }
  },
  {
    path: '/quote',
    name: 'Quote',
    component: QuotePage,
    meta: {
      title: 'Request a Quote - Omega Metal Industries',
      description: 'Submit your project details for a custom quote on CNC machining, fabrication, and industrial engineering services in Saudi Arabia.'
    }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQPage,
    meta: {
      title: 'Frequently Asked Questions - Omega Metal Industries',
      description: 'Answers to common questions about CNC machining, fabrication, quoting, lead times, API certifications, and ordering from Omega Metal Industries.'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundPage,
    meta: {
      title: 'Page Not Found - Omega Metal Industries'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    } else {
      return { top: 0, behavior: 'smooth' }
    }
  }
})

// Update document title and meta description on navigation
router.beforeEach((to, from, next) => {
  // Update title
  document.title = to.meta.title || 'Omega Metal Industries'

  // Update meta description
  const metaDescription = document.querySelector('meta[name="description"]')
  if (metaDescription && to.meta.description) {
    metaDescription.setAttribute('content', to.meta.description)
  }

  next()
})

export default router
